export default __webpack_public_path__ + "static/media/Bear Claws of Divine Might.cff145f4.jpg";